<template>
  <div class="caf">
    <div 
      v-for="{ filterKey, option } in individualFilters"
      :key="filterKey + option"
      class="caf__item"
    >
      <span class="caf__title text-sm">{{option}}</span>
      <svg class="caf__close" @click="emit('remove-filter',filterKey,option)" :aria-label="`Remove filter ${option}`" tabindex="0">
        <use xlink:href="#exit"></use>
      </svg>
    </div>
    <div class="caf__clear text-base" @click="emit('clear-filter')" tabindex="0" aria-label="Clear All Filters">Clear all</div>
  </div>
</template>

<script setup>
  import {ref, toRefs, computed} from 'vue';
  const props = defineProps({
    filters: {
      type: Object,
      required: true,
    },
  })

  const emit = defineEmits(['remove-filter','clear-filter'])
  const { filters } = toRefs(props)

  const individualFilters = computed(() => {
    return Object.entries(filters.value || {}).reduce(
      (final, [filterKey, filterOptions]) => {
        filterOptions.forEach(option => {
          final.push({
            filterKey,
            option,
          })
        })
        return final
      },
      []
    )
  })

</script>